import { useContext, useState } from "react"
import { BsImage, BsUpload } from "react-icons/bs";
import { FeatureContext } from "../../../Context"
import { createAttachment, getAttachment } from "../Services";
import DropZone from '../../../components/dropzone/DropZone';
import { lang } from "../../../Utils";
import { Button } from "../../../components/button/Button";
import { Spinner, useBoolean } from "@chakra-ui/react";

const Attachments = () => {
  const context = useContext(FeatureContext);
  const [loader, setLoader] = useBoolean();
  const [fileData, setFileData] = useState();
  const [file, setFile] = useState();

  const onChange = (fileData) => setFileData(fileData);
  const onChangeFile = (file) => setFile(file);

  const onSubmit = () => {
    setLoader.on();
    createAttachment({ enquiryId: context?.details?.enquiryId, file: fileData })
      .then(data => {
        context.setAttachments(data?.data?.attachments);
        setFile('');
      })
      .finally(_ => setLoader.off());
  }

  const onClick = (attachmentId) => {
    getAttachment(context?.details?.enquiryId, attachmentId)
      .then(data => {
        const linkSource = `data:image/${data?.data?.extensionType};base64,${data?.data?.body}`;
        const downloadLink = window.document.createElement('a');
        window.document.body.appendChild(downloadLink);
        downloadLink.href = linkSource;
        downloadLink.target = '_self';
        downloadLink.download = data?.data?.name;
        downloadLink.click();
      })
  }
  return <>
    <div>
      <DropZone onChange={onChange} onChangeFile={onChangeFile} />
      <div className="bf-enquiry-file-upload">
        <Button variant="default" disabled={!file} onClick={onSubmit}>{(loader) ? <Spinner size={'sm'} /> : <BsUpload />}<span>{lang('Upload')}</span></Button>
        {(!!file) ? <div className="dropzone-file" key={file?.path}>
          {file.path} {Math.round(file.size / 1024)} Kb
        </div> : null}
      </div>
    </div>
    <div className="bf-enquiry-file-list">
      {context?.attachments.map((attachment, index) =>
        <div key={`attachment-${index}`} onClick={() => onClick(attachment.id)}>
          <BsImage /> {attachment.name}
        </div>)}
    </div>
  </>
}

export default Attachments;